<template>
    <div>
      <!--加载框之登录超时-->
      <loading-dialog v-if="true" :type="'loginTimeout'"></loading-dialog>
    </div>
</template>

<script>
  import LoadingDialog from '../public-component/loading-dialog';
    export default {
        name: 'login-timeout',
      components: {LoadingDialog}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/login-timeout.vue